import type { SentryModule, SentryPathnameModuleRule } from '../types';

export const MODULE_ROUTE: Record<SentryModule, string> = {
  auth: '/forgot-password',
  login: '/login',
  signup: '/signup',
  // Old merchantwebapp landing (product picker)
  landing: '/landing',
  // New PG Home / landingV2
  home: '/summary/overview',
  onboarding: '/onboarding',
  payment_links: '/payment-links',
  payment_forms: '/payment-forms',
  payment_buttons: '/payment-buttons',
  payments: '/transactions/payments',
  settlements: '/settlements',
  payouts: '/payout',
  developers: '/developers',
  disputes: '/transactions/disputes',
  reports: '/reports',
  orders: '/transactions/orders',
  refunds: '/transactions/refunds',
  summary: '/summary',
  settings: '/settings',
  offers: '/offers',
  one_click_checkout: '/one-click-checkout',
  easy_split: '/easy-split',
  softpos: '/softpos',
  customers: '/customers',
  customisation: '/customisation',
  subscriptions: '/subscriptions',
  risk_shield: '/risk-shield',
  vba: '/vba-configuration',
  insights: '/summary/analytics',
  suspicious: '/transactions/suspicious',
  apps: '/apps',
  downtimes: '/status-page/downtimes',
  embedded_components: '/embedded-components',
  flowwise: '/flowwise',
  relay: '/relay',
  bbps: '/bbpscou',
  vswebapp: '/vswebapp',
  cross_border: '/cross-border',
  international_payment_gateway: '/ipg',
  global_collection: '/global-collections',
};

export const PATHNAME_MODULE_MAP: ReadonlyArray<SentryPathnameModuleRule> = [
  { prefix: '/merchants/landing', module: 'landing' },
  { prefix: '/vba-configuration', module: 'vba' },
  { prefix: '/transactions/suspicious', module: 'suspicious' },
  { prefix: '/signup', module: 'signup' },
  { prefix: '/login', module: 'login' },
  // Home vs Insights — more specific than /summary
  { prefix: '/summary/analytics', module: 'insights' },
  { prefix: '/summary/overview', module: 'home' },
  ...Object.entries(MODULE_ROUTE)
    .map(([module, prefix]) => ({
      prefix,
      module: module as SentryModule,
    }))
    .sort((a, b) => b.prefix.length - a.prefix.length),
];
